import React from 'react';
import { motion } from 'framer-motion';
export function EnemySection() {
  return <section className="py-20 px-4 bg-brand-dark border-y border-white/5" data-id="element-33">
      <div className="container mx-auto max-w-4xl text-center" data-id="element-34">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-3xl md:text-4xl font-bold text-white mb-12" data-id="element-35">
          Ya probaste todo lo que{' '}
          <span className="text-brand-red" data-id="element-36">no funciona</span>
        </motion.h2>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-37">
          {['Consejos sueltos de TikTok', "Frases 'alfa' copiadas", 'Hacerte el distante', "Ser 'demasiado atento'", 'Videos que explican teoría'].map((item, i) => <motion.div key={i} initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="bg-brand-black p-6 rounded border border-white/5 hover:border-brand-red/30 transition-colors" data-id="element-38">
              <span className="text-brand-red text-xl font-bold mr-2" data-id="element-39">❌</span>
              <span className="text-gray-300 font-medium" data-id="element-40">{item}</span>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="mt-16 max-w-2xl mx-auto" data-id="element-41">
          <p className="text-xl md:text-2xl text-gray-200 font-light" data-id="element-42">
            Nada cambia. Porque nadie te enseñó{' '}
            <span className="font-bold text-white border-b-2 border-brand-red" data-id="element-43">
              el sistema
            </span>
            .
          </p>
        </motion.div>
      </div>
    </section>;
}